import { IMutations } from '@/interfaces/Store';
import { IReview } from '../interfaces/IReview';
import { IThumbedReview } from '../interfaces/IThumbedReview';
import { IUniversity } from '../interfaces/IUniversity';
import state from './state';
import { DataStorage } from '@studyportals/data-storage';
import { IReviewStorage } from '../interfaces/IReviewStorage';
import { getLocalStorage } from './storage';
import { IGSSAResults } from '../interfaces/IGSSAResults';

const storeLocalStorage = async (assignFn: (storage: IReviewStorage) => void): Promise<void> => {
	const storage = await getLocalStorage();

	assignFn(storage);

	DataStorage.store('Reviews', JSON.stringify(storage));
};

const mutations: IMutations = {
	setLoggedInState: (loggedInState) => {
		state.loggedIn = loggedInState;
	},
	handleErrorState: () => {
		state.error = 'sync_error';
	},
	setUniversity: (university: IUniversity | null) => {
		state.university = university;
	},
	setUniversities: (universities: IUniversity[]) => {
		state.universities = universities;
	},
	flaggedReviewsAdd: async (reviewId: number): Promise<void> => {
		const index = state.flaggedReviews.indexOf(reviewId);
		if (index !== -1) {
			return;
		}

		state.flaggedReviews.push(reviewId);
		await storeLocalStorage((s) => (s.flaggedReviews = state.flaggedReviews));
	},
	flaggedReviewsRemove: async (reviewId: number): Promise<void> => {
		const index = state.flaggedReviews.indexOf(reviewId);
		if (index === -1) {
			return;
		}

		state.flaggedReviews.splice(index, 1);
		await storeLocalStorage((s) => (s.flaggedReviews = state.flaggedReviews));
	},
	thumbedReviewsAdd: async (thumbedReview: IThumbedReview): Promise<void> => {
		const index = state.thumbedReviews.findIndex((r) => r.reviewId === thumbedReview.reviewId);
		if (index !== -1) {
			return;
		}

		state.thumbedReviews.push(thumbedReview);
		await storeLocalStorage((s) => (s.thumbedReviews = state.thumbedReviews));
	},
	thumbedReviewsRemove: async (thumbedReview: IThumbedReview): Promise<void> => {
		const index = state.thumbedReviews.findIndex((r) => r.reviewId === thumbedReview.reviewId);
		if (index === -1) {
			return;
		}

		state.thumbedReviews.splice(index, 1);
		await storeLocalStorage((s) => (s.thumbedReviews = state.thumbedReviews));
	},
	thumbedReviewsUpdate: async (thumbedReview: IThumbedReview): Promise<void> => {
		const index = state.thumbedReviews.findIndex((r) => r.reviewId === thumbedReview.reviewId);
		if (index === -1) {
			return;
		}

		state.thumbedReviews.splice(index, 1);
		state.thumbedReviews.push(thumbedReview);

		await storeLocalStorage((s) => (s.thumbedReviews = state.thumbedReviews));
	},
	showWidgetReviewsAll: (popupState: boolean): void => {
		state.showPopup = popupState;
	},
	loadWidgetReviewsAll: (popupState: boolean): void => {
		state.loadPopup = popupState;
	},
	setGssaResults: (gssaResults: Map<number, IGSSAResults | null>): void => {
		state.gssaResults = gssaResults;
	},
	setReviewsPerUniversity: (reviewsPerUniversity: Map<number, IReview[]>): void => {
		state.reviewsPerUniversity = reviewsPerUniversity;
	},
	showWidgetReviewsAllPerUniversity: (popupState: Map<number, boolean>): void => {
		state.showPopupPerUniversity = popupState;
	},
};

export default mutations;
